'use strict';

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Margin = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n'], ['\n  ', '\n  ', '\n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n']);

exports.m = m;
exports.mx = mx;
exports.my = my;
exports.mt = mt;
exports.mr = mr;
exports.mb = mb;
exports.ml = ml;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _core = require('./core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function m(values) {
  return function (_ref) {
    var theme = _ref.theme;
    return (0, _core._m)(values, theme);
  };
}

function mx(values) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return (0, _core._mx)(values, theme);
  };
}

function my(values) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return (0, _core._my)(values, theme);
  };
}

function mt(values) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return (0, _core._mt)(values, theme);
  };
}

function mr(values) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return (0, _core._mr)(values, theme);
  };
}

function mb(values) {
  return function (_ref6) {
    var theme = _ref6.theme;
    return (0, _core._mb)(values, theme);
  };
}

function ml(values) {
  return function (_ref7) {
    var theme = _ref7.theme;
    return (0, _core._ml)(values, theme);
  };
}

var Margin = exports.Margin = _styledComponents2["default"].div(_templateObject, function (_ref8) {
  var inline = _ref8.inline;
  return inline && 'display: inline-block;';
}, function (_ref9) {
  var all = _ref9.all,
      theme = _ref9.theme;
  return (0, _core._m)(all, theme);
}, function (_ref10) {
  var horizontal = _ref10.horizontal,
      theme = _ref10.theme;
  return (0, _core._mx)(horizontal, theme);
}, function (_ref11) {
  var vertical = _ref11.vertical,
      theme = _ref11.theme;
  return (0, _core._my)(vertical, theme);
}, function (_ref12) {
  var top = _ref12.top,
      theme = _ref12.theme;
  return (0, _core._mt)(top, theme);
}, function (_ref13) {
  var right = _ref13.right,
      theme = _ref13.theme;
  return (0, _core._mr)(right, theme);
}, function (_ref14) {
  var bottom = _ref14.bottom,
      theme = _ref14.theme;
  return (0, _core._mb)(bottom, theme);
}, function (_ref15) {
  var left = _ref15.left,
      theme = _ref15.theme;
  return (0, _core._ml)(left, theme);
});

Margin.displayName = 'Margin';